// Error Constants - Enums and constant values for error handling
// ✅ NO MAGIC STRINGS: Use typed enums and constants

/**
 * Error severity levels
 */
export enum ErrorSeverity {
  INFO = "INFO",
  WARNING = "WARNING",
  ERROR = "ERROR",
  CRITICAL = "CRITICAL",
}

/**
 * Error sources
 */
export enum ErrorSource {
  API = "API",
  AUTH = "AUTH",
  VALIDATION = "VALIDATION",
  NETWORK = "NETWORK",
  APPLICATION = "APPLICATION",
  INTEGRATION = "INTEGRATION",
  UI = "UI",
  UNKNOWN = "UNKNOWN",
}

/**
 * Default user-friendly messages by error source
 */
export const USER_FRIENDLY_MESSAGES: Record<ErrorSource, string> = {
  [ErrorSource.API]: "A server error occurred. Please try again later.",
  [ErrorSource.AUTH]: "Authentication failed. Please log in again.",
  [ErrorSource.VALIDATION]: "Please check your input and try again.",
  [ErrorSource.NETWORK]:
    "Network connection error. Please check your internet connection.",
  [ErrorSource.APPLICATION]:
    "An application error occurred. Please refresh the page.",
  [ErrorSource.INTEGRATION]: "Something went wrong. Please try again.",
  [ErrorSource.UI]: "Something went wrong. Please try again.",
  [ErrorSource.UNKNOWN]: "Something went wrong. Please try again.",
};

/**
 * Notification duration (ms) by error severity
 */
export const NOTIFICATION_DURATIONS: Record<ErrorSeverity, number> = {
  [ErrorSeverity.CRITICAL]: 0, // Don't auto-dismiss
  [ErrorSeverity.ERROR]: 8000, // 8 seconds
  [ErrorSeverity.WARNING]: 6000, // 6 seconds
  [ErrorSeverity.INFO]: 4000, // 4 seconds
};

/**
 * Default notification duration fallback (ms)
 */
export const DEFAULT_NOTIFICATION_DURATION = 6000;

/**
 * Maximum number of errors retained in history
 */
export const MAX_HISTORY_SIZE = 100;
